import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config"; // Sube un nivel y entra a firebase/config

export const getHistorial = async () => {
  try {
    const historialCol = collection(db, 'historial_medico');
    const snapshot = await getDocs(historialCol);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error al traer historial:", error);
    return [];
  }
};